import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { heroTexts } from '../../data/scrollingTexts';

interface ScrollingTextProps {
  interval?: number; // Milliseconds between text changes
  className?: string;
}

const ScrollingText: React.FC<ScrollingTextProps> = ({
  interval = 3000,
  className = ''
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(current => (current + 1) % heroTexts.length);
    }, interval);

    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div className={`relative inline-block min-w-[200px] min-h-[1.5em] ${className}`} style={{ minWidth: '8ch' }}>
      <AnimatePresence mode="wait">
        <motion.span
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }}
          className="block text-gradient font-theme whitespace-nowrap"
        >
          {heroTexts[currentIndex]}
        </motion.span>
      </AnimatePresence>
    </div>
  );
};

export default ScrollingText;
